export default __webpack_public_path__ + "static/media/appstore.14b65a77.png";